import { Select } from '@chakra-ui/react';

import { Location } from '../models/careers';

type SelectLocationProps = {
  locations: Location[];
  onLocationSelect: (location: Location) => void;
};

export function SelectLocation({ locations, onLocationSelect }: SelectLocationProps) {
  return (
    <Select aria-label='Select Location' defaultValue='all' onChange={(event) => onLocationSelect(event.target.value)}>
      <option value='all'>All Locations</option>
      {locations?.map((location) => (
        <option key={location} value={location}>
          {location}
        </option>
      ))}
    </Select>
  );
}
